import { useEffect, useState } from 'react';
import { learnApi, type ChapterSummary } from '../api/learnApi';

/**
 * Feature 023 — the manifest chapter list, for surfaces that only need the list itself.
 *
 * `ChapterPage` deliberately does NOT use this: it fetches the list alongside the chapter content
 * in one effect so both land in the same status machine. This hook serves the callers that just
 * want the tab rail (the Study landing page).
 */
export function useChapterList(): { chapters: ChapterSummary[] | null; failed: boolean } {
  const [chapters, setChapters] = useState<ChapterSummary[] | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    learnApi
      .getChapters()
      .then((list) => {
        if (active) setChapters(list);
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, []);

  return { chapters, failed };
}
